<template>
  <div>
    <el-card>
      <div class="carditem" v-if="resultList.length">
        <div class="title" v-for="item in resultList" :key="item.index">
          <i class="el-icon-caret-right"></i>
          <p @click="godetails(item.year, item.quarter, item.title)">
            {{ item.year + "年" + item.quarter + item.title }}
          </p>
        </div>
      </div>
      <div class="empty-tip" v-else>
        <i class="el-icon-info"></i>
        <p>亲爱的用户，暂无质评成绩数据，请稍后再来查看。</p>
      </div>
      <!-- <el-button type="primary">创建上报表</el-button> -->
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currPage: 1,
      totalSize: 10,
      resultList: [],
    };
  },
  created() {
    this.getResultlist();
  },
  methods: {
    async getResultlist() {
      const { data: res } = await this.$http.post("quality/evaluate/list", {
        currPage: this.currPage,
        totalSize: this.totalSize,
        // title: "质评成绩表",
        titleCode:'3'
      });
      if (res.code !== 200) {
        this.$message.error(res.message);
      } else {
        this.resultList = res.data.records;
      }
    },
    godetails(year, quarter, title) {
      this.$router.push({
        path: "/usreslist",
        query: {
          year: year,
          quarter: quarter,
          title: title,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.empty-tip {
  text-align: center;
  padding: 80px 0;
  color: #909399;
  i {
    font-size: 48px;
    color: #c0c4cc;
  }
  p {
    margin-top: 20px;
    font-size: 16px;
  }
}
</style>